export default __webpack_public_path__ + "static/media/11.ebe4f6cb.jpg";